import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe, Languages } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-navy text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Name & Description */}
          <div>
            {/* Full Company Name */}
            <div className="mb-6">
              <h3 className="font-heading font-bold text-2xl text-white tracking-wide">
                WMJ <span className="text-gold">ENTERPRISE SERVICES</span> LLC
              </h3>
            </div>
            <p className="text-slate-300 leading-relaxed mb-4">
              Professional tax preparation, credit education, and business consulting services 
              for individuals and small businesses.
            </p>
            {/* Languages & Service Area */}
            <div className="flex flex-col gap-2 text-sm text-slate-400">
              <span className="flex items-center gap-2">
                <Globe size={14} className="text-gold" />
                Nationwide — All 50 States
              </span>
              <span className="flex items-center gap-2">
                <Languages size={14} className="text-gold" />
                English • French • Creole
              </span>
            </div>
          </div>

          {/* Contact Info - CENTER */}
          <div className="text-center">
            <h4 className="font-heading font-semibold text-lg mb-6 text-gold">Contact Us</h4>
            <div className="space-y-4 inline-block text-left">
              <a href="tel:+19014013054" className="flex items-center gap-3 text-slate-300 hover:text-gold transition-colors duration-200">
                <Phone size={18} className="text-gold" />
                <span>(901) 401-3054</span>
              </a>
              <a href="mailto:info@wmjenterpriseservices.com" className="flex items-center gap-3 text-slate-300 hover:text-gold transition-colors duration-200">
                <Mail size={18} className="text-gold" />
                <span>info@wmjenterpriseservices.com</span>
              </a>
              <a href="https://www.wmjenterpriseservices.net" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-300 hover:text-gold transition-colors duration-200">
                <Globe size={18} className="text-gold" />
                <span>www.wmjenterpriseservices.net</span>
              </a>
              <div className="flex items-start gap-3 text-slate-300">
                <MapPin size={18} className="text-gold mt-1 flex-shrink-0" />
                <span>3325 Hollywood Blvd<br />Suite 400-A<br />Hollywood, FL 33021</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-right">
            <h4 className="font-heading font-semibold text-lg mb-6 text-gold">Quick Links</h4>
            <nav className="flex flex-col space-y-3">
              <Link to="/" className="footer-link">Home</Link>
              <a href="/#services" className="footer-link">Services</a>
              <a href="/#about" className="footer-link">About Us</a>
              <Link to="/intake" className="footer-link">Client Intake</Link>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms" className="footer-link">Terms of Service</Link>
            </nav>
          </div>
        </div>

        {/* Disclaimer - Full Width */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <p className="text-slate-400 text-sm leading-relaxed">
            <strong className="text-slate-300">Disclaimer:</strong> WMJ Enterprise Services LLC is not a CPA firm or a law firm. Services provided are limited to tax preparation, credit education, and business consulting. Any tax information provided is for general informational purposes only and should not be considered legal or tax advice.
          </p>
        </div>

        {/* Data Security - Full Width */}
        <div className="border-t border-slate-700/50 mt-6 pt-6">
          <p className="text-slate-500 text-sm leading-relaxed">
            <strong className="text-slate-400">Data Security:</strong> We take the protection of your personal and financial information seriously. All data transmitted through our website is protected using industry-standard encryption and secure technology.
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-700/50 mt-6 pt-6">
          <p className="text-slate-400 text-sm text-center">
            © {new Date().getFullYear()} WMJ Enterprise Services LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
